export default __webpack_public_path__ + "static/media/SemanaNordica_Agenda_Jueves.c9eba9e6.png";